import React, {Fragment} from 'react'
import styled from 'styled-components'

const Root = styled.div`
	width: 100%;
`

const Word = styled.span`
	white-space: nowrap;
`

const CamelCaseWrap = React.memo(({ text }) =>
	typeof text === 'string' ? (
		<Root>
			{text
				.split(/([A-Z][a-z]*)/)
				.filter(Boolean)
				.map(text => (text.includes(' ') ? <Fragment key={text}>{text}</Fragment> : <Word key={text}>{text}</Word>))}
		</Root>
	) : null,
)

CamelCaseWrap.displayName = 'CamelCaseWrap'

export default CamelCaseWrap
